import { Dispatch, memo, SetStateAction } from 'react'
import { ChevronDownIcon, ChevronUpIcon, CrossIcon } from '@/assets'
import { Box } from '@/components/Layout'
import { filterDropdownClasses } from '../FilterDropdown.data'

interface FilterDropdownIconProps {
  open: boolean
  value: unknown
  handleClear: () => void
  setOpen: Dispatch<SetStateAction<boolean>>
  disabled: boolean
  enableClear: boolean
}
const FilterDropdownIcon = ({
  open,
  value,
  handleClear,
  setOpen,
  disabled,
  enableClear,
}: FilterDropdownIconProps) => {
  const hasValue = Array.isArray(value) ? value.length > 0 : Boolean(value)

  if (enableClear && hasValue)
    return (
      <Box
        className={`${filterDropdownClasses.dropdownIcon} ${filterDropdownClasses.dropdownCrossIcon}`}
        onClick={handleClear}>
        <CrossIcon />
      </Box>
    )

  return (
    <Box
      className={
        disabled
          ? `${filterDropdownClasses.dropdownIcon} ${filterDropdownClasses.disabled}`
          : filterDropdownClasses.dropdownIcon
      }
      onClick={() => {
        if (disabled) return
        setOpen(true)
      }}>
      {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Box>
  )
}

export default memo(FilterDropdownIcon)
